import React, { useEffect, useState } from "react";
import InputForm, {
  AutoCompleteValue,
} from "../../Components/InputForm/InputForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import "../MemberRegistration/PersonalDetails.css";
import {
  documentDetails,
  insertUpdateKyc,
  getKycId,
  getConfigValues,
} from "../../Helpers/APIEndPoints/EndPoints";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import validator from "validator";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import "./KYCDetails.css";
import MemberRegistrationStatus, {
  MemberRegistrationModule,
} from "../../Components/MemberRegistrationStatus/MemberRegistrationStatus";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { useLocation, useNavigate } from "react-router-dom";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { Decrypt } from "../../Helpers/Cryptography/Crypto";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import {
  randomEmail,
  randomMobile,
  randomNumber,
  randomString,
} from "../../Helpers/Common";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { enableTestData } from "../../Helpers/Constants/Constants"; 

const KYCDetails = (props) => {
  let navigate = useNavigate();
  const { state } = useLocation();
  // const location = useLocation();
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [data, setData] = useState({
    accholderName: "",
    bankName: "",
    ifscCode: "",
    accountNumber: null,
    aadharNo: null,
    panNo: null,
    confirmAccountNo: null,
    emailId: "",
    // panName:null,
    mobileNumber: null,
    uploadCheque: null,
    micrCode: null,
    uploadPan: null,
    // chqName:null,
    statusId: null,
    statusName: null,
    rejectedRemarks: [],
    branchName: null,
  });
  let documentId = [];
  const [disabled, setDisabled] = useState(false);
  const [panName, setPanName] = useState(null);
  const [chqName, setchqName] = useState(null);
  const [error, setError] = React.useState<any>({});
  const [binaryDataPan, setBinaryData] = useState(null);
  const [binaryDataChq, setBinaryChq] = useState(null);
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const [panRegex, setPanRegex] = useState(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
  const [adhaarRegex, setAdhaarRegex] = useState(/^\d{12}$/);
  // const ifscRegex = /^[A-Za-z]{4}\d{7}$/;
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const memberid =
    GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";

  useEffect(() => {
    // getConfigData();
    getKYCDetails();
  }, []);

  const { previous, next } = props;
  const getBase64FromFilePromise = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (isFile(file) === true) {
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
      }
      reader.onerror = (error) => reject(error);
    });

  const onChange = async (key, value) => {
    if (key === "uploadPan" && value.target.files.length > 0) {
      let errormessage = "panError";

      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["jpeg", "png", "jpg", "pdf"];
      let validfile = e.split(".").pop();
      setPanName(e);
      if (!extension.includes(validfile)) {
        await setError({
          ...error,
          [errormessage]: "File should be only jpeg or png or pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        await setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        await setError({
          ...error,
          [errormessage]: "",
        });
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }

        setBinaryData(fileBase64);

        value = fileBase64;
      }
    }
    await setData({ ...data, [key]: value });
  };

  const onChangeUploadCheque = async (key, value) => {
    if (key == "uploadCheque" && value.target.files.length > 0) {
      let errormessage = "chqError";
    
      let e = value.target.files[0].name;
      let file = value.target.files[0];
      let extension = ["jpeg", "png", "jpg", "pdf"];
      let validfile = e.split(".").pop();
      setchqName(e);
      if (!extension.includes(validfile)) {
        await setError({
          ...error,
          [errormessage]: "File should be only jpeg or png or pdf",
        });
        value = file.name;
      } else if (file.size / 1024 / 1024 > 2) {
        await setError({
          ...error,
          [errormessage]: "Please select file size upto 2mb",
        });
        value = file.name;
      } else {
        await setError({
          ...error,
          [errormessage]: "",
        });
        let tempString = await getBase64FromFilePromise(file);
        let fileBase64 = "";
        if (tempString && tempString !== "") {
          fileBase64 = String(tempString).split("base64,")[1];
        }
        setBinaryChq(fileBase64);
        value = fileBase64;
      }
    }
    await setData({ ...data, [key]: value });
  };

  

  const onSubmit = async () => {
    debugger
    let errorObj = {};
    debugger
    // if (data.accountNumber === null || data.accountNumber === undefined) {
      if (!data?.branchName) {
        errorObj = {
          ...errorObj,
          branchName: "This field is required",
          // [data.accountNumber]: "This field is required",
        };
      }
    // if (data.accountNumber === null || data.accountNumber === undefined) {
    if (!data?.accountNumber) {
      errorObj = {
        ...errorObj,
        accountNumber: "This field is required",
        // [data.accountNumber]: "This field is required",
      };
    }
    // if (data.aadharNo === null || data.aadharNo === undefined) {
    if (!data?.emailId) {
      errorObj = {
        ...errorObj,
        ["emailvalidation"]: "This field is required",
      };
    }
    // if (data.panNo === null || data.panNo === undefined) {
    if (!data?.panNo) {
      errorObj = {
        ...errorObj,
        panNo: "This field is required",
        // [data.panNo]: "This field is required",
      };
    }
    // if (data.accholderName === "" || data.accholderName === undefined) {
    if (!data?.accholderName) {
      errorObj = {
        ...errorObj,
        accholderName: "This field is required",
        // [data.accholderName]: "This field is required",
      };
    }
    // if (data.bankName === "" || data.bankName === undefined) {
    if (!data?.bankName) {
      errorObj = {
        ...errorObj,
        bankName: "This field is required",
        // accountNumber: "This field is required",
        // [data.accountNumber]: "This field is required",
      };
    }
    // if (data.ifscCode === "" || data.ifscCode === undefined) {
    if (!data?.ifscCode) {
      errorObj = {
        ...errorObj,
        ifscCode: "This field is required",
        // [data.ifscCode]: "This field is required",
      };
    }
    // if (data.confirmAccountNo === null || data.confirmAccountNo === undefined) {
    if (!data?.confirmAccountNo) {
      errorObj = {
        ...errorObj,
        confirmAccountNo: "This field is required",
        // [data.confirmAccountNo]: "This field is required",
      };
    }
    if (panName === null || panName === undefined) {
      errorObj = {
        ...errorObj,
        [panName]: "This field is required",
        // [panName]: "This field is required",
      };
    }

    // if (data.mobileNumber === null || data.mobileNumber === undefined) {
    if (!data?.mobileNumber) {
      errorObj = {
        ...errorObj,
        mobileNumber: "This field is required",
        // [data.mobileNumber]: "This field is required",
      };
    } else if (data.mobileNumber.length != 10) {
      errorObj = {
        ...errorObj,
        mobileNumber: "Mobile number should be 10 digit",
        // [data.mobileNumber]: "Mobile number should be 10 digit",
      };
    }
    if (chqName === null || chqName === undefined) {
      errorObj = {
        ...errorObj,
        [chqName]: "This field is required",
      };
    }

    // if (!data?.micrCode) {
    //   errorObj = {
    //     ...errorObj,
    //     [data.micrCode]: "This field is required",
    //   };
    // }

    if (!data?.micrCode) {
      errorObj = {
        ...errorObj,
        micrCode: "MICR Number is required",
        // [data.micrCode]: "MICR Number is required",
      };
    }else if (!/^\d{9}$/.test(data?.micrCode)) {
      errorObj = {
        ...errorObj,
        micrCode: "MICR Number must be 9 digits",
        // [data.micrCode]: "MICR Number must be 9 digits",
      };
    }

    if (
      data.accountNumber != null &&
      data.accountNumber != data.confirmAccountNo
    ) {
      errorObj = {
        ...errorObj,
        confirmAccountNo:
          "Account Number and Confirm Account does not match",
          // [data.confirmAccountNo]:
          // "Account Number and Confirm Account does not match",
      };
    }

    if (!binaryDataPan) {
      errorObj = {
        ...errorObj,
        ["panError"]: "Invalid PAN",
      };
    }

    if (!binaryDataChq) {
      errorObj = {
        ...errorObj,
        ["chqError"]: "Invalid Cheque",
      };
    }

    if (Object.keys(errorObj).length === 0) {
      showLoader();
      try {
        let kyc = await getKYCDetails();
        if (
          kyc === null ||
          [
            ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
            ApplicationStatus.MemberRegistrationModule_Draft,
          ].includes(kyc?.StatusId)
        ) {
          if (
            ApplicationStatus.MemberRegistrationModule_RejectedHRHOD ==
              kyc?.StatusId &&
            chqName === kyc.CheckdocName &&
            panName === kyc.PandocName
          ) {
            let obj = [
              { uploadCheque: kyc.CancelledChecqueDocId },
              { uploadPan: kyc.PANDocId },
            ];
            documentId = obj;
          } else {
            for (const key in data) {
              if (key == "uploadPan" || key == "uploadCheque") {
                let param = {
                  DocumentName: key == "uploadPan" ? panName : chqName,
                  DocumentType: panName.split(".").pop(),
                  DocumentUrl: "",
                  BinaryFile:
                    key === "uploadPan" ? data.uploadPan : data.uploadCheque,
                  //  IsActive: true
                };
                const insertData = await APICall(documentDetails, param);
                if (insertData.Status === ApiStatus.OK && insertData?.Data) {
                  let obj = { [key]: insertData.Data };
                  documentId.push(obj);
                } else {
                  notify(
                    ToastType.Error,
                    insertData?.Message ||
                      "Failed to upload document, Please try again later."
                  );
                  return;
                }
              }
            }
          }
          let obj = {
            MemberId: Number(memberid),
            AccountHolderName: data.accholderName,
            BankName: data.bankName,
            IFSCCode: data.ifscCode,
            AccountNo: String(data.accountNumber),
            AadharNo: String(data.aadharNo),
            PANNo: data.panNo,
            ConfirmAccountNo: String(data.confirmAccountNo),
            EmailId: data.emailId,
            RegisteredMobileNo: String(data.mobileNumber),
            PANDocId: documentId[1].uploadPan,
            CancelledChecqueDocId: documentId[0].uploadCheque,
            MICRCode: String(data.micrCode),
            IsActive: true,
            BranchName: data.branchName,
          };
          const insertKyc = await APICall(insertUpdateKyc, obj);
          if (insertKyc.Message == "Ok" && insertKyc.Data != null) {
            let statusData = await next();
            setStatusData(statusData);
            if (
              [
                ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
                ApplicationStatus.MemberRegistrationModule_Draft,
              ].includes(statusData.StatusId)
            ) {
              setDisabled(false);
            } else {
              setData({ ...data, statusId: statusData.StatusId });
              setDisabled(true);
            }
          } else {
            notify(1, insertKyc?.Message);
          }


          hideLoader();
        } else {
          // if (
          //   data.statusId ===
          //   ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam
          // ) {
          let statusDetails = await next();
          setStatusData(statusDetails);
          hideLoader();
          // }
        }
      } catch (err) {
      } finally {
        hideLoader();
      }
    }
    setError(errorObj);
  };

  const isFile = (input: any) => "File" in window && input instanceof File;

  // const getConfigData = async () => {
  //   const config = ["panRegex", "adhaarRegex", "ifscRegex"];

  //   const configdata = await APICall(getConfigValues, { Keys: config });

  //   if (configdata.Message == "Ok" && configdata.Data.length > 0) {
  //     configdata.Data.map((cd) => {
  //       if (cd.Key === "panRegex") {
  //         setPanRegex(cd.Value);
  //       }
  //       if (cd.Key === "adhaarRegex") {
  //         setAdhaarRegex(cd.Value);
  //       }
  //       if (cd.Key === "ifscRegex") {
  //         setIfscRegex(cd.Value);
  //       }
  //     });
  //   }
  // };

  const getKYCDetails = async () => {
    // if (location.search) {

    //   const params = new URLSearchParams(location.search);
    //   if (params.has("memberid")) {
    // let memberid = Decrypt(params.get("memberid"));
    // let encMemberId = decodeURI(params.get("memberid"));
    // let memberid = Decrypt(encMemberId);
    // let encMemberId = params.get("memberid");
    // let memberid = decodeURIComponent(Decrypt(encMemberId));
    // setMemberId(memberid);
    let url = `${getKycId}`;
    let requestBody = { MemberId: memberid };

    const getData = await APICall(url, requestBody);
   
    if (getData.Data != null) {
      // setDisabled(true);

      if (
        getData.Data.StatusId ==
          ApplicationStatus.MemberRegistrationModule_Draft ||
        getData.Data.StatusId ==
          ApplicationStatus.MemberRegistrationModule_RejectedHRHOD
      ) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }

      let obj = {
        accholderName: getData.Data.AccountHolderName,
        bankName: getData.Data.BankName,
        ifscCode: getData.Data.IFSCCode,
        accountNumber: getData.Data.AccountNo,
        aadharNo: getData.Data.AadharNo,
        panNo: getData.Data.PANNo,
        confirmAccountNo: getData.Data.ConfirmAccountNo,
        emailId: getData.Data.EmailId,

        mobileNumber: getData.Data.RegisteredMobilNo,
        uploadCheque: null,
        micrCode: getData.Data.MICRCode,
        uploadPan: null,
        statusId: getData.Data.StatusId,
        statusName: getData.Data.StatusName,
        rejectedRemarks: getData?.Data?.RejectedRemarks?.split("\n") || [],
        branchName: getData.Data.BranchName,
      };
      setData(obj);
      setBinaryData("asd");
      setBinaryChq("asd");
      setchqName(getData.Data.CheckdocName);
      setPanName(getData.Data.PandocName);
    }
    return getData.Data;
    //   }
    // }
  };

  const handleKeyNumbers = (event) => {
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      // Prevent numeric character input
      event.preventDefault();
    }
  };
  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };
  

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    let acc = randomNumber(1111111111, 9999999999);
    let newData = {
      accholderName: randomString(12),
      bankName: randomString(8),
      ifscCode: `IFSC0${randomNumber(111111, 999999)}`,
      accountNumber: acc,
      aadharNo: randomNumber(111111111111, 999999999999),
      panNo: `${randomString(5)}${randomNumber(1111, 9999)}${randomString(1)}`,
      confirmAccountNo: acc,
      emailId: randomEmail(),
      mobileNumber: randomMobile(),
      uploadCheque: null,
      micrCode: randomNumber(111111111111, 999999999999),
      uploadPan: null,
      statusId: data.statusId,
      statusName: data.statusName,
      rejectedRemarks: [],
      branchName:data.branchName,
    };
    setData(newData);
  };

  const handleCopy = (event) => {
    event.preventDefault();
    return;
  }

  const handlePaste = (event) => {
    event.preventDefault();
    return;
  };

  return (
    <div className="">
      <MemberRegistrationStatus
        statusId={data?.statusId || statusData?.StatusId}
        memberRegistrationModule={MemberRegistrationModule.KYCDetails}
        rejectReasons={data.rejectedRemarks}
      />
      <div className="col-lg-12 col-md-12 p-0">
        <div className="row">
          <div
            className="col-lg-4 col-sm-4 col-xs-4 "
            style={{ marginTop: "15px" }}
          >
            <div className="form-group">
              <label onDoubleClick={testData}>Account Holder Name</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={data.accholderName}
                maxlength={30}
                onChange={(val: any) => {
                  let value = val.target.value;
                  const regex = /^[a-zA-Z]/;
                  if (value === "" || regex.test(value)) {
                    if (value.length > 30) {
                      value = value.slice(0, 30);
                    }
                    onChange("accholderName", value);
                  }
                }}
                isDisabled={disabled}
                type="text"
                onKeyPress={handleKeyNumbers}
              />
              {error.accholderName && <p style={{ color: "red" }}>{error.accholderName}</p>}
              {/* {error[data.accholderName] && (
                <p style={{ color: "red" }}>{error[data.accholderName]}</p>
              )} */}
            </div>
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Bank Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={30}
              value={data.bankName}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[a-zA-Z]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 30) {
                    value = value.slice(0, 30);
                  }
                  onChange("bankName", value);
                }
              }}
              type="text"
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
             {error.bankName && <p style={{ color: "red" }}>{error.bankName}</p>}
            {/* {error[data.bankName] && (
              <p style={{ color: "red" }}>{error[data.bankName]}</p>
            )} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Branch Name</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={30}
              value={data.branchName}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[a-zA-Z]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 30) {
                    value = value.slice(0, 30);
                  }
                  onChange("branchName", value);
                }
              }}
              type="text"
              isDisabled={disabled}
              onKeyPress={handleKeyNumbers}
            />
             {error.branchName && <p style={{ color: "red" }}>{error.branchName}</p>}
            {/* {error[data.bankName] && (
              <p style={{ color: "red" }}>{error[data.bankName]}</p>
            )} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>IFSC Code</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={11}
              value={data.ifscCode}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = new RegExp(ifscRegex);
                if (!regex.test(value)) {
                  setError({
                    ...error,
                    ifscValidation: "Please enter a valid IFSC number.",
                  });
                } else {
                  setError({ ...error, ifscValidation: "" });
                }
                onChange("ifscCode", value);
              }}
              type="text"
              isDisabled={disabled}
            />
            {error.ifscCode ? (
              <p style={{ color: "red" }}>{error.ifscCode}</p>
            ) : error["ifscValidation"] ? (
              <p style={{ color: "red" }}>{error["ifscValidation"]}</p>
            ) : null}
             {/* {error[data.ifscCode] ? (
              <p style={{ color: "red" }}>{error[data.ifscCode]}</p>
            ) : error["ifscValidation"] ? (
              <p style={{ color: "red" }}>{error["ifscValidation"]}</p>
            ) : null} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Account Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={20}
              value={data.accountNumber}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 20) {
                    value = value.slice(0, 20);
                  }
                  onChange("accountNumber", value);
                }
              }}
              type="number"
              isDisabled={disabled}
              onKeyPress={(e) => handleKeyPress(e)}
              onWheel={(e) => e.target.blur()}
              onPaste={handlePaste} 
              onCopy={handleCopy}
            />
            {error.accountNumber && (
              <p style={{ color: "red" }}>{error.accountNumber}</p>
            )}
            {/* {error[data.accountNumber] && (
              <p style={{ color: "red" }}>{error[data.accountNumber]}</p>
            )} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Aadhaar No</label>
            {/* <sup>*
            </sup> */}
            {/* New Comment */}
            {/* <sup>*
            </sup> */}
            <InputForm
              placeholder={""}
              maxlength={12}
              value={data.aadharNo}
              onChange={(val: any) => {
                let value = val.target.value;




                // if (value.length < 13) {
                //   const regex = adhaarRegex;
                //   if (!regex.test(value)) {
                //     setError({
                //       ...error,
                //       adharValidation: "Please enter a valid Adhar number.",
                //     });
                //   } else {
                //     setError({ ...error, adharValidation: "" });
                //   }
                //   onChange("aadharNo", value);
                // }
                onChange("aadharNo", value);
              }}
              type="number"
              isDisabled={disabled}
              onKeyPress={(e) => handleKeyPress(e)}
              onWheel={(e) => e.target.blur()}
            />
            {/* {error[data.aadharNo] ? (
              <p style={{ color: "red" }}>{error[data.aadharNo]}</p>
            // ) : 
            // error["adharValidation"] ? (
            //   <p style={{ color: "red" }}>{error["adharValidation"]}</p>
            ) : null} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>PAN No</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={10}
              value={data.panNo}
              onChange={(val: any) => {
                let value = val.target.value.toUpperCase();

                const regex = panRegex;

                if (!regex.test(value)) {
                  setError({
                    ...error,
                    panValidation: "Please enter a valid PAN number.",
                  });
                } else {
                  setError({ ...error, panValidation: "" });
                }
                onChange("panNo", value);
              }}
              type="text"
              isDisabled={disabled}
            />
            {error[data.panNo] ? (
              <p style={{ color: "red" }}>{error[data.panNo]}</p>
            ) : error["panValidation"] ? (
              <p style={{ color: "red" }}>{error["panValidation"]}</p>
            ) : null}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Confirm Account Number</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={20}
              value={data.confirmAccountNo}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 20) {
                    value = value.slice(0, 20);
                  }
                  onChange("confirmAccountNo", value);
                }
              }}
              type="number"
              isDisabled={disabled}
              onKeyPress={(e) => handleKeyPress(e)}
              onWheel={(e) => e.target.blur()}
              onPaste={handlePaste} 
              onCopy={handleCopy}
            />
           {error && error.confirmAccountNo && (
              <p style={{ color: "red" }}>{error.confirmAccountNo}</p>
            )}
          </div>

          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Email Id</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              value={data.emailId}
              onChange={(val: any) => {
                let value = val.target.value;
                if (value && !validator.isEmail(value)) {
                  setError({
                    ...error,
                    emailvalidation: "Please enter a valid email",
                  });
                } else {
                  setError({ ...error, emailvalidation: "" });
                }
                onChange("emailId", value);
              }}
              type="text"
              isDisabled={disabled}
            />
            {error["emailvalidation"] ? (
              <p style={{ color: "red" }}>{error["emailvalidation"]}</p>
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Upload PAN No</label>
            <sup>*</sup>

            <input
              autoComplete={AutoCompleteValue}
              name="file-8[]"
              id="file-8-uploadPan"
              className="form-control inputfile inputfile-6"
              onChange={(e) => onChange("uploadPan", e)}
              type="file"
              disabled={disabled}
            />
            <label
              htmlFor="file-8-uploadPan"
              className="form-control"
              style={{ border: "none" }}
            >
              <span style={{ float: "right" }}>{panName}</span>
              <strong
                style={{
                  width: "30%",
                  left: "0",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
              >
                <i className="far fa-file"></i> Browse
              </strong>{" "}
            </label>
            {error[panName] || error["panError"] ? (
              <p style={{ color: "red" }}>
                {error[panName] || error["panError"]}
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Registered Mobile number Linked to Bank account</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={10}
              value={data.mobileNumber}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  onChange("mobileNumber", value);
                }
              }}
              onKeyPress={(e) => handleKeyPress(e)}
              type="number"
              isDisabled={disabled}
              onWheel={(e) => e.target.blur()}
            />
            {error.mobileNumber && (
              <p style={{ color: "red" }}>{error.mobileNumber}</p>
            )}
            {/* {error[data.mobileNumber] && (
              <p style={{ color: "red" }}>{error[data.mobileNumber]}</p>
            )} */}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>Upload Cheque No</label>
            <sup>*</sup>

            <input
              autoComplete={AutoCompleteValue}
              name="file-8[]"
              id="file-8-chque"
              className="form-control inputfile inputfile-6"
              onChange={(e) => onChangeUploadCheque("uploadCheque", e)}
              type="file"
              disabled={disabled}
            />
            <label
              htmlFor="file-8-chque"
              className="form-control"
              style={{ border: "none" }}
            >
              <span style={{ float: "right" }}>{chqName}</span>
              <strong
                style={{
                  width: "30%",
                  left: "0",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                }}
              >
                <i className="far fa-file"></i> Browse
              </strong>
            </label>
            {error[chqName] || error["chqError"] ? (
              <p style={{ color: "red" }}>
                {error[chqName] || error["chqError"]}
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4 ">
            <div className="form-group"></div>
            <label>MICR Code</label>
            <sup>*</sup>
            <InputForm
              placeholder={""}
              maxlength={9}
              value={data.micrCode}
              onChange={(val: any) => {
                let value = val.target.value;

                const regex = /^[0-9]/;
                if (value === "" || regex.test(value)) {
                  if (value.length > 9) {
                    value = value.slice(0, 9);
                  }
                  onChange("micrCode", value);
                }
              }}
              type="number"
              isDisabled={disabled}
              onKeyPress={(e) => handleKeyPress(e)}
              onWheel={(e) => e.target.blur()}
            />
            {error.micrCode && (
              <p style={{ color: "red" }}>{error.micrCode}</p>
            )}
            {/* {error[data.micrCode] && (
              <p style={{ color: "red" }}>{error[data.micrCode]}</p>
            )} */}
          </div>
        </div>
        <div
          className="p-2 d-flex justify-content-end"
          style={{ marginTop: 20 }}
        >
          <ButtonComponent
            icon={"fas fa-arrow-left"}
            value={"Back"}
            onClick={previous}
          />
          <ButtonComponent
            icon={"fa-solid"}
            value={"Exit"}
            style={{ marginLeft: "10px" }}
            className="btn btn-primary"
            onClick={() => navigate("/")}
          />
          {statusData?.StatusId &&
          [
            ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
          ].includes(statusData?.StatusId) ? null : (
            <ButtonComponent
              icon={"fas fa-arrow-right"}
              value={
                [
                  ApplicationStatus.MemberRegistrationModule_Draft,
                  ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
                ].includes(statusData?.StatusId)
                  ? "Submit"
                  : "Next"
              }
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={onSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default KYCDetails;
